export const EXPORT_FORMATS = {
  FORMAT_CSV: "csv",
  FORMAT_PAYCHEX2: "paychex2",
  FORMAT_DATA_TECH_CSV: "dataTechcsv",
  FORMAT_DATA_TECH_CSV2: "dataTechcsv2",
  FORMAT_IIF: "iif",
  FORMAT_IIF2: "iif2",
  FORMAT_IIF_MAX: "iif_max",
  FORMAT_FLSA: "flsa",
  FORMAT_WAMS_CSV: "wams_csv",
  FORMAT_CUSTOM_TIMECARD_CSV: "custom_timecard_csv",
  FORMAT_QBD_TAG: "qbd-tag",
  FORMAT_CUSTOM_ADP: "custom_adp",
  FORMAT_JOB_COSTING_XLS: "jobCostingXls",
  FORMAT_JOB_COSTING_PDF: "jobCostingPdf",
  FORMAT_JOB_COSTING_PDF2: "jobCostingPdf2",
  FORMAT_JOB_COSTING_DETAIL_XLS: "jobCostingDetailXls",
  FORMAT_JOB_COSTING_DETAIL_PDF: "jobCostingDetailPdf",
  FORMAT_JOB_COSTING_DETAIL_PDF2: "jobCostingDetailPdf2",
  FORMAT_ADP_XLS: "ADPXls",
  FORMAT_ADP_XLS2: "ADPXls2",
  FORMAT_PAY_DATA_CSV: "payDatacsv",
  FORMAT_MILEAGE_CSV: "mileagecsv",
  FORMAT_SOUTH_EAST_CSV: "southEastCsv",
  FORMAT_AUDIT_XLS: "auditXls",
  FORMAT_AUDIT_XLS2: "auditXls2",
  FORMAT_AUDIT_XLS3: "auditXls3",
  FORMAT_AUDIT_PDF: "auditPDF",
  FORMAT_ADJUSTMENT_XLS: "adjustmentXls",
  FORMAT_SAGE_CSV: "sageExportcsv",
  FORMAT_ISOLVED_CSV: "iSolvedCsv",
  FORMAT_ISOLVED_XLS: "iSolvedXls",
  FORMAT_MIKE_ROVNER_CSV: "mikerovnercsv",
  FORMAT_MEALS_FLAG: "mealsFlagExport",
  FORMAT_FENCE_FACTORY_XLS: "fenceFactoryXls",
  FORMAT_PTO_BALANCE_CSV: "ptoBalanceCsv",
  FORMAT_PAYLOCITY_CSV: "paylocityCsv",
  FORMAT_FAMOUS_EXPORT: "famousexporttxt",
  FORMAT_MMCHR: "mmchrExport",
  FORMAT_PDF: "pdf",
  FORMAT_PDF_2: "pdf2",
  FORMAT_XLS: "xls",
  FORMAT_XLSX: "xlsx",
  FORMAT_SAGE_CSV2: "sageExportcsv2",
  FORMAT_PAYCOM_CSV: "paycomCsv",
  FORMAT_QB_ONLINE_IMPORT: "qbOnlineImport",
  FORMAT_QB_ONLINE_XLSX: "qbOnlineXlsx",
  FORMAT_SPLIT_SESSION_VIEW: "split_session_view",
};

export const PARAM_INCLUDE_MEAL = "include_meal";